export interface DriverListing {
  id: string;
  name: string;
  email?: string;
  phone?: string;
  licenseNumber: string;
}

export class DriverList {
  constructor(public readonly drivers: DriverListing[]) {}
}
